import React from 'react';

import MapThemes from './MapThemes';
import Layers from './Layers';

import SidebarIntro from '../layout/SidebarIntro';
import SidebarHeader from '../layout/SidebarHeader';

const SidebarLayers = ({ onClose }) => (
  <>
    <SidebarHeader onClose={onClose} />
    <SidebarIntro>
      <h2>Map Theme</h2>
    </SidebarIntro>
    <MapThemes />
    <br />
    <Layers />
  </>
)

export default SidebarLayers;